import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import * as jwt_decode from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { MatRadioChange, MatRadioButton } from '@angular/material/radio';
import { LoginRequestVM } from 'src/app/viewModels/login/login-request-vm';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { TokenValidateRequestVM } from 'src/app/viewModels/login/token-validate-request-vm';
import { CommonService } from 'src/app/middleware/common/common.service';
import { CommonDialogComponent } from 'src/app/middleware/shared/dialogueBoxes/common/common-dialog.component';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { CookieService } from 'ngx-cookie-service';
import { timer } from 'rxjs';
import { HttpClient,HttpBackend } from '@angular/common/http';
import { DOCUMENT, DatePipe } from '@angular/common';
const { detect } = require('detect-browser');
const browser = detect();

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [DatePipe]
})
export class LoginComponent implements OnInit {

  constructor(private http: HttpClient,private httpbackend:HttpBackend,private _formBuilder: FormBuilder,
    private loginRequestVM: LoginRequestVM, private encryptionAlgo: EncryptionService, 
    private reusableClass: ReusableClasses, private authService: AuthService, private statusConst: StatusConstant,
    private tokenValidationReqVM: TokenValidateRequestVM, private commonService: CommonService,
    private matDialog: MatDialog, public dialogRef: MatDialogRef<CommonDialogComponent>,
    private loaderService: LoaderService, private toastr: ToastrService, private router: Router,
    private constant: Constants,private route: ActivatedRoute,private dialog: MatDialog,
    private customValidator: CustomvalidationService,private cookieService: CookieService,
    public datepipe: DatePipe,
    @Inject(DOCUMENT) private document: Document
    ) {
      var skipper = new HttpClient(httpbackend);
      skipper.get<{ip:string}>('https://jsonip.com').subscribe( data => {       
        this.ipAddress = data.ip;
      });
  }

  ipAddress:any;
  browsername:any;
  device:any;

  //Observables and Variables will go here...
  loginForm: FormGroup;
  loginResponseHolder: any;
  loginToken: any;
  twofactorToken: any;
  validateTokenResponseHolder: any;
  decodedUserData: any;
  password: any = "";
  enableLoginButton: boolean = false;
  displayValidatorField: boolean = false;
  tokenValidator: any;
  enableConfirmButton: boolean = false;
  showLoginForm: boolean = false;
  isPhoneExist: boolean = false;
  isemailChecked : boolean = false;
  permissionsAssigned: any[] = [];
  organizationID: any;
  databaseID: any;
  folderAccess: any[] = [];
  Email:string="";
  Token:string="";
  hidenew = true;
  rememberMe:boolean=false;
  LoggedInEmailId:string="";
  ContinueButton:boolean=false;
  passworderror:string="";
  spinner:boolean=false;
  //Observables and Variables will go here...
  menuModules: any[] = [];
  browserversion:string="";
  associatedAPIs: any[] = [];

  ngOnInit(): void {
   // var test="rs7RMr%2BJXFaf6GgscbYzqlWxQImjJAIIbCj71eyF7ihh2LdG9LPQJ%2Bl0tNbXKV4vL4KRjF9CKy%2BNRKGuLISECDUaBCAX72akTSC1%2FmVFhnwB0B6y8oCLQJkwkHxw6RL1l0hqON9KW4B3XqloF8J8mWVxDHFXtXkA8%2BqJhcnBB4Xjae91kx93gxMCzlv1743VmPsOFTuRVIlbz%2BC%2B6%2FunGVS9nv2hy9o9VEvO%2BO6qWzeVf%2Bi0vHcv1idTLcVLIWZXSDk5fjLYjnRHp1cXPLvyN719YqO6uFqeb1xLbTUnjOelBwmQnRwTCOSi44ZkdSOMSW%2FAvZfd68H%2BF7taskda5OYL3C1zynXhsl9Ag9SXPBgpp%2BrNRxGWXuZbDWTBapZT%2BDjbd%2FHxv%2F%2FnmCJ9BMcyeAFx4wjdBUZ1XQsvmt2BFMLPEOUec6xbbpSe%2Bixv24nl0gcHUFE3sUSEmzQbg3AD8hA91pPEFHzViK6dHgjaUJ20eF%2Fon%2Bgp7iI3bHezy8S8sdI8hbP5IZpO%2FakEofhytBbkWn2Wx%2FXXdzGpfctvXIY%3D";
   // var t = this.encryptionAlgo.get(this.reusableClass.decryptionKey,test);
    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
      this.browserversion = browser.version;
    }
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      //password: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      tokenValidator: ['']
    });
    
    let token = sessionStorage.getItem('userToken');
    let menuModules = sessionStorage.getItem('menuModules');
    if((token == undefined || token == null || token == '') || (menuModules == undefined || menuModules == null || menuModules == '')) {
      this.getQueryParameter();          
      // var useremail=sessionStorage.getItem("UserActivationEmail");
      // var usertoken = sessionStorage.getItem("UserActivationToken");
      // if(useremail != undefined && useremail != null && useremail != '' && usertoken != undefined && usertoken != null && usertoken != ''){
      //   this.Email=sessionStorage.getItem("UserActivationEmail");
      //   this.Token=sessionStorage.getItem("UserActivationToken");
      //   this.VerifyEmail();
      // }
      this.logout();
      if (!sessionStorage.getItem('foo')) {
        //sessionStorage.setItem('foo', 'no reload');
        //location.reload(); 
      } else {
        //this.getQueryParameter();
        sessionStorage.removeItem('foo');
      }     
    }
    else{
        sessionStorage.setItem('HeaderModuleName','Dashboard');
        this.router.navigate(['/dashboard']);
        return;
      // var UserActivationEmail = sessionStorage.getItem("UserActivationEmail");
      // var UserActivationToken = sessionStorage.getItem("UserActivationToken");
      // var alreadyLogin = sessionStorage.getItem('alreadyLogin');
      // if(UserActivationEmail!="" && UserActivationToken!="" && alreadyLogin=='yes'){
      //   this.Email = UserActivationEmail;
      //   this.Token = UserActivationToken;
      //   this.VerifyEmail();
      // }else{
      //   sessionStorage.setItem('HeaderModuleName','Dashboard');
      //   this.router.navigate(['/dashboard']);
      //   return;
      // }
    }
    
  }


  


  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.Email = params['Email'];
      this.Token = params['Token'];
      if(this.Email!=undefined && this.Token!=undefined){
        this.VerifyEmail();
      }
      if(this.Email!=undefined && this.Token==undefined){      
        var email = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.Email);
        this.cookieService.delete('email');
        this.cookieService.set('email',  email);
        this.loginForm.controls.email.setValue(email);
      }
      
    });
  }

  VerifyEmail() {
    var email = encodeURIComponent(this.Email); //this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.Email);
    var token = encodeURIComponent(this.Token); //this.encryptionAlgo.get(this.reusableClass.decryptionKey,"QlyaEQi3P1yy9rdP9jek2JuqeyJxLFHRMZs1vjiXEfo%3D");
    var emailset = this.encryptionAlgo.get(this.reusableClass.decryptionKey,this.Email);
    this.loaderService.show();
    //this.authService.VerifyEmail(this.Email,this.Token).subscribe(response => {
    this.authService.VerifyEmail(email,token).subscribe(response => {
    //this.authService.VerifyEmail(encodeURIComponent(decodeURIComponent(this.Email)),encodeURIComponent(decodeURIComponent(this.Token))).subscribe(response => {
      if (response) {
        this.loaderService.hide();
        this.validateTokenResponseHolder = response;
        if (this.validateTokenResponseHolder.status == this.statusConst.statusSuccess) {         
          this.cookieService.delete('email');
          this.cookieService.set('email',  emailset);
          this.loginForm.controls.email.setValue(emailset);
          sessionStorage.removeItem("UserActivationEmail");
          sessionStorage.removeItem("UserActivationToken");
          sessionStorage.removeItem('alreadyLogin');
          sessionStorage.clear();
          this.toastr.success("Account is activated successfully", '', {
            timeOut: 3000,
          });
        }
       else{
        sessionStorage.clear();
        this.loaderService.hide();
       }
      }else{
        sessionStorage.clear();
        this.loaderService.hide();
      }
    });
  }

  
  //Summary
  //Encrytpion with AES256 has been applied for un/pass.
  login(loginDetails) {
    if (loginDetails != undefined) {      
      // this.showLoginForm = true;
       let copyModel = Object.assign({}, this.loginRequestVM);
       copyModel.UserName = (loginDetails.value.email).toLowerCase();
       this.LoggedInEmailId=(loginDetails.value.email).toLowerCase();
       copyModel.UserName = this.encryptionAlgo.set(this.reusableClass.encryptionKey, copyModel.UserName);
       copyModel.Password = loginDetails.value.password;
       copyModel.Password = this.encryptionAlgo.set(this.reusableClass.encryptionKey, copyModel.Password);
       this.loginRequestVM = copyModel;

       this.cookieService.set('email', loginDetails.value.email);
       this.cookieService.set('password', loginDetails.value.password);
       var ReqModels={
        userName: copyModel.UserName,
        password: copyModel.Password,
        rememberMe: true,
      }
      this.loaderService.show();
      this.spinner=true;
      this.authService.userLogin(ReqModels).subscribe(response => {
        if (response) {
          this.loginResponseHolder = response;
          this.loaderService.hide();
          this.spinner=false;
          if (this.loginResponseHolder.data.loginAttempt.isSuccess == true) {
            sessionStorage.setItem("isMasterPasswordLogin",response.data.loginAttempt.isMasterPasswordLogin);
            if(this.loginResponseHolder.data.loginAttempt.isMFA==false){
              this.tokenValidationReqVM.authenticationType = "email";
              this.tokenValidationReqVM.isOfficeChanged = false;
              this.tokenValidationReqVM.isMFALogin = false;
              this.tokenValidationReqVM.userName = copyModel.UserName;
              this.validateToken("000000");
            }
            if(this.loginResponseHolder.data.loginAttempt.isMFA==true){
             this.twofactorToken = this.loginResponseHolder.data;
             let validateTokenCopyModel = Object.assign({}, this.tokenValidationReqVM);
             validateTokenCopyModel.userName = this.loginRequestVM.UserName;
             validateTokenCopyModel.authenticationType = this.loginRequestVM.AuthenticationType;
             this.tokenValidationReqVM = validateTokenCopyModel;
             this.tokenValidationReqVM.isOfficeChanged = false;
             this.tokenValidationReqVM.userName = copyModel.UserName;
             this.tokenValidationReqVM.isMFALogin = this.loginResponseHolder.data.loginAttempt.isMFA;
             this.loginRequestVM = copyModel;
             this.showLoginForm = true;
             this.isPhoneExist = this.loginResponseHolder.data.loginAttempt.isPhoneExist;
             if(this.isPhoneExist==false){
              this.isemailChecked=true;
              this.loginRequestVM.AuthenticationType = this.constant.Email;
              this.ContinueButton=true;
             }else{
              this.ContinueButton=false;
              this.isemailChecked=false;
             }
             this.displayValidatorField = true;
            }            
          }
          else {
            var LoginCountFailed;
            LoginCountFailed = this.loginResponseHolder.data.loginAttempt.attemptCount;
            if(LoginCountFailed>6){
              LoginCountFailed=6;
            }          
           
            sessionStorage.setItem('LoginCountFailed',LoginCountFailed);
            this.toastr.warning('Invalid login attempts '+LoginCountFailed+' out of 6, Please provide valid details to process your login.', '', {
              timeOut: 4000,
            });
            if(Number(LoginCountFailed)==6){
              var date = this.getNowUTC();
             // this.min = 1;
              this.min = 15;
              this.sec = 0;
              this.min = this.min * 60;
              this.sec = this.sec % 60;
              this.totalTime = this.min + this.sec;
              this.timerClock();
              this.enableLoginButton=false;
              sessionStorage.setItem('LoginTimer',date.toString());
              sessionStorage.removeItem("LoginCountFailed");
            }
            this.spinner=false;
            this.displayValidatorField = false;
            this.showLoginForm = false;            
          }
        }
      });
    }
  }

  rememberMeChecked(event): void {
    this.cookieService.set('rememberMe', event.checked);
  }

  //Summary
  //Authentication Type will be added in request parameters.
  getAuthenticationMethod(value: MatRadioChange) {
    this.ContinueButton=true;
    let mrButton: MatRadioButton = value.source;
    if (mrButton.value == "1") {
      this.loginRequestVM.AuthenticationType = this.constant.Email;
    }
    else {
      this.loginRequestVM.AuthenticationType = this.constant.Phone;
    }
  }
    
  //Summary
  //LoginForm will be send as request parameters.
  loginApiCall() {
    if (this.loginRequestVM.AuthenticationType != undefined) {
      var attempt={
        ipAddress: this.ipAddress,
        device: this.device,
        browser: this.browsername + ' ' +this.browserversion,
        macId: ""
      }
      
      this.loginRequestVM.attempt=attempt;
      this.ContinueButton=false;
      this.loaderService.show();
      this.spinner=true;
      this.tokenValidator="";
      this.enableConfirmButton=false;
      this.authService.login(this.loginRequestVM).subscribe(response => {
        if (response) {
          this.loginResponseHolder = response;
          this.loaderService.hide();
          this.spinner=false;
          if (this.loginResponseHolder.data.loginAttempt.isSuccess == true) {
            this.twofactorToken = this.loginResponseHolder.data;
            let validateTokenCopyModel = Object.assign({}, this.tokenValidationReqVM);
            validateTokenCopyModel.userName = this.loginRequestVM.UserName;
            validateTokenCopyModel.authenticationType = this.loginRequestVM.AuthenticationType;
            this.tokenValidationReqVM = validateTokenCopyModel;
            this.showLoginForm = false;
            this.displayValidatorField = true;
          }
          else {
            var LoginCountFailed;
            LoginCountFailed = this.loginResponseHolder.data.loginAttempt.attemptCount;
            if(LoginCountFailed>6){
              LoginCountFailed=6;
            }           
            // LoginCountFailed = sessionStorage.getItem('LoginCountFailed');
            // if(LoginCountFailed==null || LoginCountFailed==undefined){
            //   LoginCountFailed=1;
            // }else{
            //   LoginCountFailed=Number(LoginCountFailed)+1;
            // }
            sessionStorage.setItem('LoginCountFailed',LoginCountFailed);
            this.toastr.warning('Invalid login attempts '+LoginCountFailed+' out of 6, Please provide valid details to process your login.', '', {
              timeOut: 4000,
            });
            if(Number(LoginCountFailed)==6){
              var date = this.getNowUTC();
             // this.min = 1;
              this.min = 15;
              this.sec = 0;
              this.min = this.min * 60;
              this.sec = this.sec % 60;
              this.totalTime = this.min + this.sec;
              this.timerClock();
              this.enableLoginButton=false;
              sessionStorage.setItem('LoginTimer',date.toString());
              sessionStorage.removeItem("LoginCountFailed");
            }
            this.spinner=false;
            this.displayValidatorField = false;
            this.showLoginForm = false;
            // this.toastr.error( this.loginResponseHolder.message+','+ "Username or Password is incorrect.", '', {
            //   timeOut: 3000,
            // });
          }
        }
      });
    }
    else{ 
      this.spinner=false;
      this.toastr.warning( "Please select Authentication type.", '', {
        timeOut: 3000,
      });
    }    
  }
  
  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  display: string="";
  interval: any;

  totalTime: number;
  min: number;
  sec: number;
  subscribe: any;
  clockTimer: string = '00 : 00';  

  timerClock() {
    let minutes, seconds, formatedMinutes, formatedSeconds;
    let nTime = this.totalTime;

    const source = timer(0, 1000);
    this.subscribe = source.subscribe(val => {
        if (this.totalTime === -1) {
          this.enableLoginButton=true; 
          this.display="";
          sessionStorage.removeItem("LoginCountFailed");
          sessionStorage.removeItem("LoginTimer");
          this.subscribe.unsubscribe();
        } else {
          minutes = Math.floor(this.totalTime / 60);
          seconds = this.totalTime % 60;

          formatedMinutes = minutes > 9 ? minutes : '0' + minutes;
          formatedSeconds = seconds > 9 ? seconds : '0' + seconds;
          this.totalTime = nTime - val;

          this.display = `${formatedMinutes} min : ${formatedSeconds}` + ' sec';
        }
      });
  }

   
  //tokenValidationReqVM will be send as request parameters.
  //Will return the token for authentication purposes.
  validateToken(passcode) {
    this.enableConfirmButton=false;
    this.tokenValidationReqVM.twoFactorCode = passcode;
    //Api call to validate token..
    this.loaderService.show();
    this.spinner=true;
    this.authService.validateToken(this.tokenValidationReqVM).subscribe(response => {
      if (response) {
        this.loaderService.hide();
        this.spinner=false;
        this.validateTokenResponseHolder = response;       
        if (this.validateTokenResponseHolder.status == this.statusConst.statusSuccess) {
          this.loginToken = this.validateTokenResponseHolder.data.token;
          this.permissionsAssigned =this.validateTokenResponseHolder.data.permissions;        
          this.databaseID = this.validateTokenResponseHolder.data.databaseID;
          this.organizationID = this.validateTokenResponseHolder.data.organizationID;
          this.folderAccess = this.validateTokenResponseHolder.data.folders;
          this.menuModules =  this.validateTokenResponseHolder.data.menuModules;
          this.associatedAPIs = this.validateTokenResponseHolder.data.associatedAPIs;
          sessionStorage.setItem('profileImagePath', this.validateTokenResponseHolder.data.profileImagePath);
          sessionStorage.setItem('folderAccess', JSON.stringify(this.folderAccess));
          sessionStorage.setItem('associatedAPIs', JSON.stringify(this.associatedAPIs));
          sessionStorage.setItem('officeList', JSON.stringify(this.validateTokenResponseHolder.data.officeList));
          sessionStorage.setItem('userContactID', this.validateTokenResponseHolder.data.userContactID);
          sessionStorage.setItem('roleIDList', this.validateTokenResponseHolder.data.roleIDList);
          sessionStorage.setItem('roles', JSON.stringify(this.validateTokenResponseHolder.data.roles));       
          sessionStorage.setItem('email', this.LoggedInEmailId);
          this.decodedUserData = jwt_decode(this.loginToken);
         
          this.commonService.setLoggedInUserDetails(this.decodedUserData, this.loginToken,
            this.permissionsAssigned,this.menuModules, this.databaseID, this.organizationID);
            sessionStorage.removeItem("UserActivationEmail");
            sessionStorage.removeItem("UserActivationToken");
            sessionStorage.removeItem('alreadyLogin');
            sessionStorage.removeItem("LoginCountFailed");
            sessionStorage.removeItem("LoginTimer");
            var checks:any=[]=[];
             checks=this.menuModules[0];
             if(checks!=null){
              sessionStorage.setItem('HeaderModuleName', checks.orgModuleName);
              if(checks.mainModuleName=="Dashboard"){
                this.router.navigate(['/dashboard']);
              }
              if(checks.mainModuleName=="Core"){
                this.router.navigate(['/core/listing']);
              }
              if(checks.mainModuleName=="Contact"){
                this.router.navigate(['/contact/listing']);
              }
              if(checks.mainModuleName=="Company"){
                this.router.navigate(['/company/listing']);
              }
              if(checks.mainModuleName=="Forms"){
                sessionStorage.setItem('esignatureMenuActive', 'true');
                sessionStorage.setItem('esignatureMenuSharedActive', 'false');
                sessionStorage.setItem('isSharedWithMeForm', 'false');
                sessionStorage.setItem('MasterTemplatePDFForm', 'false');
                sessionStorage.setItem('MasterTemplateTabularForm', 'false');
                sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
                sessionStorage.setItem('MasterTemplateWebForm','false');
                this.router.navigate(['/esignature']);                
              }
              if(checks.mainModuleName=="File Manager"){
                sessionStorage.setItem('FileManagerMenuActive', 'true');
                sessionStorage.setItem('FileManagerMenuSharedActive', 'false');
                sessionStorage.setItem('isSharedWithMeFileManager', 'false');
                this.router.navigate(['/filemanager']);
              }             
              if(checks.mainModuleName=="Chat"){
                this.router.navigate(['/chat']);
              }
              if(checks.mainModuleName=="New Task" || checks.mainModuleName=="Task"){
                this.router.navigate(['/task']);
              }
             }
            //this.router.navigate(['/dashboard']);  

           this.toastr.success("Logged in successfully.", '', {
            timeOut: 3000,
           });         
          //Setting userdetails in service for further use of token and details..                
        }
       else{
        this.enableConfirmButton=true;
        this.spinner=false; 
         this.toastr.error(this.validateTokenResponseHolder.message+' or '+"Validating token is not correct.", '', {
          timeOut: 3000,
        });       
       }
      }
    });
  }

 

  //Summary
  //clear localStorage and logout user.
  // logout() {
  //   this.commonService.logoutUser();
  // }

  //clear localStorage and logout user
  logout(){
    var emailcookie = this.cookieService.get('email');
    var passwordcookie = this.cookieService.get('password');
    var rememberMecookie = this.cookieService.get('rememberMe');    
    if(rememberMecookie=='true'){
      this.loginForm.controls.email.setValue(emailcookie);
      this.loginForm.controls.password.setValue(passwordcookie);
      this.password=passwordcookie;
      this.rememberMe = true;
      this.enableLoginButton = true;
    }else{
      this.loginForm.controls.email.setValue('');
      this.loginForm.controls.password.setValue('');
      this.password="";
      this.rememberMe = false;
      this.enableLoginButton = false;
    }

    var LoginCountFailed;
    var LoginTimer;
    LoginCountFailed = sessionStorage.getItem('LoginCountFailed');
    LoginTimer = sessionStorage.getItem('LoginTimer');
    sessionStorage.clear();  
    if(LoginCountFailed==null || LoginCountFailed==undefined){
      LoginCountFailed=0;
    }
    sessionStorage.setItem('LoginCountFailed',LoginCountFailed);
    this.router.navigate(['/auth/login']);
    if(LoginTimer !=null && LoginTimer!=undefined && LoginTimer!='' &&  LoginTimer!='null'){
      sessionStorage.setItem('LoginTimer',LoginTimer);
      var todaydate = this.getNowUTC();
      var toUTC = new Date(LoginTimer);
      var newtodaydate =this.datepipe.transform(todaydate, 'yyyy-MM-dd');
      var newtoUTC=this.datepipe.transform(toUTC, 'yyyy-MM-dd');
      if(newtodaydate>newtoUTC){
       // LoginCountFailed=0;
       sessionStorage.removeItem("LoginCountFailed");
       sessionStorage.removeItem("LoginTimer");   
      }
      if(newtodaydate==newtoUTC){
        // var hour = todaydate.getHours();
        // var min = todaydate.getMinutes();
        // var sec = todaydate.getSeconds();
  
        // var hourTimer = toUTC.getHours();
        // var minTimer = toUTC.getMinutes();
        // var secTimer = toUTC.getSeconds();
        var getNewDateTime = new Date(toUTC);
        var newt = new Date(getNewDateTime.getTime()+ 15*60000);
       // var newt = new Date (as.getTime()+ 1*60000);
        if(todaydate>newt){
        // LoginCountFailed=0;
        sessionStorage.removeItem("LoginCountFailed");
        sessionStorage.removeItem("LoginTimer");
        }else{
          // var hour = todaydate.getHours();
          // var min = todaydate.getMinutes();
          // var sec = todaydate.getSeconds();
    
          // var hourTimer = newt.getHours();
          // var minTimer = newt.getMinutes();
          // var secTimer = newt.getSeconds();  
        
          // const days = ((newt.getDate() - todaydate.getDate()) / (1000 * 60 * 60 * 24));
          const hours = (Math.abs(newt.getTime() - todaydate.getTime()) / (1000 * 60 * 60) % 24);
          const minutes = (Math.abs(newt.getTime() - todaydate.getTime()) / (1000 * 60) % 60);
          const seconds = (Math.abs(newt.getTime() - todaydate.getTime()) / (1000) % 60); 
      
          var newmin = Math.floor(minutes); // minTimer-min;
          var newsec =  Math.floor(seconds);//secTimer-sec;
  
          this.min = newmin;
          this.sec = newsec;
          this.min = this.min * 60;
          this.sec = this.sec % 60;
          this.totalTime = this.min + this.sec;
          this.timerClock();
          this.enableLoginButton=false;         
        }
      }
    }
   
  
    // sessionStorage.removeItem("userToken");
    // sessionStorage.removeItem("permissions");
    // sessionStorage.removeItem("databaseId");
    // sessionStorage.removeItem("organizationID");
    // sessionStorage.removeItem("profileImagePath");
    // sessionStorage.removeItem("moduleName");
    // sessionStorage.removeItem("localFiltersContact");
    // sessionStorage.removeItem("localFiltersCompany");
    // sessionStorage.removeItem("localFilters");
    // sessionStorage.removeItem("folderAccess");
    // sessionStorage.removeItem("transactionID");
    // sessionStorage.removeItem("HeaderModuleName");
    // sessionStorage.removeItem("DashboardRefresh");
    // sessionStorage.removeItem("email");
    // sessionStorage.removeItem("roles");
    // sessionStorage.removeItem("roleIDList");
    // sessionStorage.removeItem("userContactID");
    // sessionStorage.removeItem("stepCompleted");
    // sessionStorage.removeItem("esignatureMenuActive");
    // sessionStorage.removeItem("esignatureMenuSharedActive");
    // sessionStorage.removeItem("ProjectName");  
  }
   
  copyPasteInputToken(){
    if(this.tokenValidator!=null && this.tokenValidator!=undefined && this.tokenValidator!="" 
      && this.tokenValidator.length == 6){
      this.enableConfirmButton = true;
    }else{
      this.enableConfirmButton = false;
    }  
  }

  checkPassLength() {
    if(this.display!=""){
      this.enableLoginButton = false;
    }else{
      this.enableLoginButton = true;
    }
   
    // if (this.password.length > 7) {
    //   this.enableLoginButton = true;
    // }
    // else {
    //   this.enableLoginButton = false;
    //   this.passworderror="password of at least eight characters";
    // }
  }

  // Get Errors for password field
  getErrorPasswordLogin() {
    return this.customValidator.getErrorPasswordLogin(this.loginForm);
  }

  //Summary
  //Check Validate token length and enable Confirm button
  checkValidatorLength() {
    if (this.tokenValidator.length == 6) {
      this.enableConfirmButton = true;
    }
    else {
      this.enableConfirmButton = false;
    }
  }


  showLogin(){
    this.showLoginForm = false;
    this.displayValidatorField = false;
  }


}
